module.exports = __webpack_public_path__ + "static/img/1024_1024 透明.ed3195f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1024_1024 透明.png
// module id = xH4b
// module chunks = 3